import { useMemo, useState } from 'react';

import { useNavigationStack } from '../../../context/NavigationStackContext';
import { useGetAvailableExercises } from '../../../redux/api/exercisesAPI';
import {
  useDeleteProgramSet,
  useGetProgramSetById,
} from '../../../redux/api/programsAPI';
import { Paths } from '../../../shared/paths';
import { IProgramSet } from '../../../types/interfaces/program-set';
import { orderProgramSet } from '../../../utils/training/set-utils';

export function useViewProgramSetComponent(setId: string) {
  const {
    data: programSetResponse,
    error,
    isError,
    isLoading: isProgramSetLoading,
    isFetching: isProgramSetFetching,
    refetch,
  } = useGetProgramSetById(setId);
  const { data: availableExercises, isLoading: isExercisesLoading } =
    useGetAvailableExercises();
  const [deleteProgramSet] = useDeleteProgramSet();
  const { navigate, back } = useNavigationStack();
  const [showDeleteConfirmation, setShowDeleteConfirmation] =
    useState<boolean>(false);

  const orderedProgramSet: IProgramSet = useMemo(() => {
    if (!programSetResponse || !availableExercises) return null;

    const exercise = availableExercises.find(
      (e) => e.id === programSetResponse.exerciseId,
    );

    return orderProgramSet(programSetResponse, exercise);
  }, [programSetResponse, availableExercises]);

  function handleEdit() {
    navigate(Paths.programs.toEditSetId(setId));
  }

  function handleDelete() {
    deleteProgramSet({ setId })
      .unwrap()
      .then((response) => {
        setShowDeleteConfirmation(false);
        back();
      })
      .catch((e) => console.log(e));
  }

  return {
    programSet: orderedProgramSet,
    isLoading:
      isProgramSetLoading || isProgramSetFetching || isExercisesLoading,
    isError,
    error,
    refetch,
    handleEdit,
    handleDelete,
    showDeleteConfirmation,
    setShowDeleteConfirmation,
  };
}
